import { useState, useEffect } from 'react';
import { config } from '../config';

export const useAuthToken = () => {
  const [token, setToken] = useState<string>('');

  // Загружаем токен из localStorage при инициализации
  useEffect(() => {
    const savedToken = localStorage.getItem(config.auth.tokenKey);
    if (savedToken) {
      setToken(savedToken);
    }
  }, []);

  // Функция для установки токена
  const updateToken = (newToken: string) => {
    setToken(newToken);
    if (newToken) {
      localStorage.setItem(config.auth.tokenKey, newToken);
    } else {
      localStorage.removeItem(config.auth.tokenKey);
    }
  };

  // Функция для очистки токена
  const clearToken = () => {
    setToken('');
    localStorage.removeItem(config.auth.tokenKey);
  };

  return {
    token,
    updateToken,
    clearToken,
  };
}; 